module.exports = __webpack_public_path__ + "img/15.1d210475.jpg";